<p-dialog
    header="Cancel pay link"
    [visible]="!!(viewModel$ | async)?.target"
    [modal]="true"
    [draggable]="false"
    [closable]="!(viewModel$ | async)?.target?.cancelling"
    [closeOnEscape]="!(viewModel$ | async)?.target?.cancelling"
    [dismissableMask]="!(viewModel$ | async)?.target?.cancelling"
    [breakpoints]="{ '48rem': '95vw' }"
    [style]="{ width: '28rem', maxWidth: '95vw' }"
    (visibleChange)="!$event && store.dispatch(actions.cancelPayLinkDismissed())"
>
    <ng-container *ngIf="viewModel$ | async as viewModel">
        <ng-container *ngIf="viewModel.target as target">
            <p class="p-mt-0">
                Cancel the <strong>{{ viewModel.amount | currency }}</strong> pay link
                on this job? The customer will no longer be able to pay it, and the
                transaction is marked cancelled.
            </p>
            <p class="p-text-secondary p-text-sm" *ngIf="target.payUrl">{{ target.payUrl }}</p>
            <p class="p-text-secondary p-mb-0">
                A link that has already been paid cannot be cancelled — refund the
                payment instead.
            </p>
        </ng-container>
    </ng-container>
    <ng-template pTemplate="footer">
        <div *ngIf="viewModel$ | async as viewModel">
            <p-button
                label="Keep link"
                severity="secondary"
                [text]="true"
                [disabled]="viewModel.target?.cancelling"
                (onClick)="store.dispatch(actions.cancelPayLinkDismissed())"
            ></p-button>
            <p-button
                label="Cancel pay link"
                severity="danger"
                [loading]="viewModel.target?.cancelling"
                [disabled]="viewModel.target?.cancelling"
                (onClick)="store.dispatch(actions.cancelPayLinkConfirmed())"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
